
import React, { useState, useEffect } from "react";
import sampleVideo from "../../../../images/image1.png";
import axios from "axios";
import {
  getAdvertisement,
  addAdvertisement,
  updateAdvertisement,
  deleteAdvertisement,
} from "../../../Servicefile/couponService.jsx";
const Landingabout = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [adId, setAdId] = useState(null);
  // FINAL DISPLAY STATES (SHOWN IN UI)
  const [title1, setTitle1] = useState("Food that makes");
  const [title2, setTitle2] = useState("you happy");
  const [desc, setDesc] = useState(
    "While eating at a restaurant is an enjoyable occasional treat, most individuals and families prepare meals at home."
  );
  const [finalMedia, setFinalMedia] = useState(sampleVideo); // video default

  // POPUP TEMP STATES
  const [pTitle1, setPTitle1] = useState("");
  const [pTitle2, setPTitle2] = useState("");
  const [pDesc, setPDesc] = useState("");
  const [pImage, setPImage] = useState(null);
  const [pVideo, setPVideo] = useState(null);
  const [mediaFile, setMediaFile] = useState(null);

  // IMAGE UPLOAD
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => setPImage(reader.result);
    reader.readAsDataURL(file);
  };
  useEffect(() => {
    const fetchAdvertisement =
      async () => {
        try {
          const token =
            localStorage.getItem(
              "authToken"
            );

          const adminId =
            localStorage.getItem(
              "userId"
            );

          const data =
            await getAdvertisement(
              adminId,
              token
            );

          if (
            !data ||
            !data.mediaFile
          )
            return;

          setAdId(data.id);

          const titleWords =
            data.title
              ?.trim()
              .split(" ");

          setTitle1(
            titleWords
              .slice(0, -1)
              .join(" ")
          );

          setTitle2(
            titleWords
              .slice(-1)
              .join(" ")
          );

          setDesc(
            data.description ?? ""
          );

          setFinalMedia(
            data.mediaFile
          );
        } catch (error) {
          console.error(
            "GET Advertisement Error:",
            error
          );
        }
      };

    fetchAdvertisement();
  }, []);

  // VIDEO UPLOAD data not visualized in the reality of the particular 
  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setPVideo(url);
  };


  const handleUpdate =
    async () => {
      try {
        const token =
          localStorage.getItem(
            "authToken"
          );

        if (!adId) {
          alert(
            "No advertisement to update!"
          );
          return;
        }

        const formData =
          new FormData();

        const dataObject = {
          id: adId,
          title: `${pTitle1} ${pTitle2}`,
          description: pDesc,
          adminId: Number(
            localStorage.getItem(
              "userId"
            )
          ),
        };

        formData.append(
          "data",
          new Blob(
            [JSON.stringify(dataObject)],
            {
              type: "application/json",
            }
          )
        );

        if (mediaFile) {
          formData.append(
            "file",
            mediaFile
          );
        }

        await updateAdvertisement(
          adId,
          formData,
          token
        );

        alert(
          "Advertisement Updated!"
        );

        setOpenPopup(false);

        window.location.reload();
      } catch (error) {
        console.error(error);

        alert(
          "Update failed!"
        );
      }
    };


  const handleDelete =
    async () => {

      if (!adId) {
        alert(
          "No advertisement found to delete"
        );
        return;
      }

      if (
        !window.confirm(
          "Are you sure you want to delete?"
        )
      )
        return;

      try {

        const token =
          localStorage.getItem(
            "authToken"
          );

        await deleteAdvertisement(
          adId,
          token
        );

        alert(
          "Advertisement deleted successfully!"
        );

        setFinalMedia("");
        setTitle1(
          "Food that makes"
        );

        setTitle2(
          "you happy"
        );

        setDesc(
          "While eating at a restaurant is an enjoyable occasional treat, most individuals and families prepare meals at home."
        );

        setAdId(null);

        window.location.reload();

      } catch (error) {

        console.error(error);

        alert(
          "Failed to delete advertisement!"
        );
      }
    };

  // SAVE POPUP DATA
  const handleSave =
    async () => {

      const adminId =
        localStorage.getItem(
          "userId"
        );

      const token =
        localStorage.getItem(
          "authToken"
        );

      if (!adminId) {
        alert(
          "Admin ID missing!"
        );
        return;
      }

      if (
        !adId &&
        !mediaFile
      ) {
        alert(
          "Please upload image or video"
        );
        return;
      }

      try {

        const formData =
          new FormData();

        const dataObject = {
          id: adId || 0,
          title: `${pTitle1} ${pTitle2}`,
          description: pDesc,
          adminId:
            Number(adminId),
        };

        formData.append(
          "data",
          new Blob(
            [JSON.stringify(dataObject)],
            {
              type: "application/json",
            }
          )
        );

        if (mediaFile) {
          formData.append(
            "file",
            mediaFile
          );
        }

        if (adId) {

          await updateAdvertisement(
            adId,
            formData,
            token
          );

        } else {

          await addAdvertisement(
            adminId,
            formData,
            token
          );
        }

        alert(
          adId
            ? "Advertisement Updated!"
            : "Advertisement Added!"
        );

        setOpenPopup(false);

        window.location.reload();

      } catch (error) {

        console.error(
          "Advertisement Error:",
          error
        );

        alert(
          "Failed to upload advertisement!"
        );
      }
    };



  return (
    <>
      <style>{`
        .food-banner2 {
          display: flex;
          flex-direction: column;ss
          align-items: center;
          background: #4e1f5cff;
          border-radius: 10px;
          color: #fff;
          padding: 40px 5%;
          width: 65vw;
          position:relative;
        }
    .add-btn-subscription {
          position: absolute;
          top: 10px;
          right: 76px;
          background: rgb(230 109 51);
          border: none;
          padding: 8px 20px;
          border-radius: 8px;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          font-weight: bold;
          z-index: 10;
          
        }

        /* POPUP OVERLAY */
        .popupOverlaySub {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        /* POPUP CONTAINER */
        .popupContainerSub {
          width: 380px;
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          position: relative;
          color: black;
          box-shadow: 0px 4px 20px rgba(0,0,0,0.2);
        }

        .closeIconSub {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          color: #333;
        }

        .popupInput {
          width: 100%;
          padding: 10px;
          margin-bottom: 12px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .popupTextarea {
          width: 100%;
          padding: 10px;
          height: 70px;
          margin-bottom: 12px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .saveBtnSub {
          background: rgb(230 109 51);
          color: #fff;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;
          width: 100%;
          font-weight: bold;
          margin-top: 10px;
        }
        /* Top Heading */
        .top-section2 {
          text-align: center;
          margin-bottom: 50px;
          max-width: 800px;
        }

        .top-section2 h2 {
          font-size: 2.8rem;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .top-section2 p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #f0f0f0;
        }

        /* Banner Content */
        .banner-content2 {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          gap: 30px;
          margin-top:30px;
        }

        /* Left Section */
        .banner-left2 {
          flex: 1 1 300px;
          max-width: 600px;
        }

        .banner-left2 h1 {
          font-size: 2.8rem;
          font-weight: bold;
          line-height: 1.3;
          margin-bottom: 20px;
        }

        .banner-left2 p {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        /* Right Section (Video) */
        .banner-right2 {
          flex: 1 1 300px;
          max-width: 600px;
          text-align: center;
        }

        .video-box2 {
          width: 100%;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }

        .video-box2 video {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .top-section2 h2 {
            font-size: 2.2rem;
          }
          .banner-left2 h1 {
            font-size: 2.2rem;
          }
        }

        @media (max-width: 768px) {
          .banner-content2 {
            flex-direction: column;
            align-items: center;
          }

          .banner-left2,
          .banner-right2 {
            max-width: 100%;
          }

          .banner-left2 h1 {
            font-size: 2rem;
          }

          .banner-left2 p {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .food-banner2 {
            padding: 30px 3%;
            width:100%
          }

          .banner-left2 h1 {
            font-size: 1.6rem;
          }

          .banner-left2 p {
            font-size: 0.9rem;
          }

          .video-box2 {
            width: 100%;
          }
        }
      `}</style>

      <div className="container-fluid">
        <div className="row">

          <div className="col-lg-8 col-md-12 col-sm-12 col-12">

            {/* MAIN BANNER */}
            <div className="food-banner2">

              {/* ADD BUTTON */}
              <button className="add-btn-subscription"
                onClick={() => {
                  setPTitle1(title1);
                  setPTitle2(title2);
                  setPDesc(desc);
                  setOpenPopup(true);
                }}
              >
                {adId ? "✏️ Edit" : "➕ Add"}
              </button>

              <button
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  background: "rgb(230 109 51)",
                  color: "#fff",
                  border: "none",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  zIndex: 20
                }}
                onClick={handleDelete}

              >
                🗑
              </button>
              {/* BANNER CONTENT */}
              <div className="banner-content2">
                <div className="banner-left2">
                  <h1>
                    {title1} <br /> {title2}
                  </h1>
                  <p>{desc}</p>
                </div>

                <div className="banner-right2">
                  {finalMedia?.endsWith(".mp4") ? (
                    <video src={finalMedia} autoPlay muted loop playsInline style={{ width: "100%", borderRadius: "10px" }} />
                  ) : (
                    <img src={finalMedia} alt="media" style={{ width: "100%", borderRadius: "10px" }} />
                  )}
                </div>
              </div>
            </div>

            {/* POPUP */}
            {openPopup && (
              <div className="popupOverlaySub">
                <div className="popupContainerSub">

                  <span className="closeIconSub" onClick={() => setOpenPopup(false)}>
                    ✖
                  </span>

                  <br /><br />

                  <input
                    type="text"
                    placeholder="Title 1"
                    className="popupInput"
                    value={pTitle1}
                    onChange={(e) => setPTitle1(e.target.value)}
                  />

                  <input
                    type="text"
                    placeholder="Title 2"
                    className="popupInput"
                    value={pTitle2}
                    onChange={(e) => setPTitle2(e.target.value)}
                  />

                  <textarea
                    placeholder="Description"
                    className="popupTextarea"
                    value={pDesc}
                    onChange={(e) => setPDesc(e.target.value)}
                  ></textarea>

                  <input
                    type="file"
                    accept="image/*,video/*"
                    className="popupInput"
                    onChange={(e) => setMediaFile(e.target.files[0])}
                  />




                  <button
                    className="saveBtnSub"
                    onClick={adId ? handleUpdate : handleSave}
                  >
                    {adId ? "Update" : "Save"}
                  </button>


                </div>
              </div>
            )}

          </div>


        </div>
      </div>
    </>
  );
};

export default Landingabout;
